
import { NodeDefinition } from '../types';

export const NODE_REGISTRY: Record<string, NodeDefinition> = {
  'text-node': {
    type: 'text-node',
    label: 'Text Input',
    inputs: [],
    outputs: [{ key: 'out_text', type: 'STRING', label: 'Text' }],
    canDelete: true,
    canCopy: true,
    defaultData: { text: '' },
  },
  'dynamic-prompt': {
    type: 'dynamic-prompt',
    label: 'Dynamic Prompt',
    inputs: [],
    outputs: [{ key: 'out_text', type: 'STRING', label: 'Text' }],
    canDelete: true,
    canCopy: true,
    defaultData: { template: '', text: '', inputFields: [] },
    width: 300,
  },
  'upload-image': {
    type: 'upload-image',
    label: 'Upload Image',
    inputs: [],
    outputs: [{ key: 'out_img', type: 'IMAGE', label: 'Image' }],
    canDelete: true,
    canCopy: true,
    defaultData: { filename: '', url: '' },
  },
  'gen-image': {
    type: 'gen-image',
    label: 'Gen Image',
    inputs: [
      { key: 'in_text', type: 'STRING', label: 'Prompt', maxConnections: 5 },
      { key: 'in_imgs', type: 'IMAGE', label: 'Ref Image', maxConnections: 14 }
    ],
    outputs: [{ key: 'out_res', type: 'GEN_IMAGE', label: 'Task' }],
    canDelete: true,
    canCopy: true,
    defaultData: {
      image_size: '1024x1024',
      aspect_ratio: '1:1',
      num_images: 1,
      model: 'gemini-2.5-flash-image',
      negative_prompt: '',
      template_id: undefined,
      maxConnections: 3
    },
    width: 300,
  },
  'gen-video': {
    type: 'gen-video',
    label: 'Gen Video',
    inputs: [
      { key: 'in_text', type: 'STRING', label: 'Prompt', maxConnections: 1 },
      { key: 'in_text_negative', type: 'STRING', label: 'Negative Prompt', maxConnections: 1 },
      { key: 'in_img_ref', type: 'IMAGE', label: 'Ref Frame', maxConnections: 1 },
      { key: 'in_img_first', type: 'IMAGE', label: 'First Frame', maxConnections: 1 },
      { key: 'in_img_last', type: 'IMAGE', label: 'Last Frame', maxConnections: 1 }
    ],
    outputs: [{ key: 'out_res', type: 'GEN_VIDEO', label: 'Task' }],
    canDelete: true,
    canCopy: true,
    defaultData: { width: 256, height: 256, duration: 8, template: 'High Quality' },
  },
  'result-image': {
    type: 'result-image',
    label: 'Image Result',
    inputs: [{ key: 'in_res', type: 'GEN_IMAGE', label: 'Task', maxConnections: 1 }],
    outputs: [{ key: 'out_pass', type: 'IMAGE', label: 'Image' }],
    canDelete: true,
    canCopy: false,
    defaultData: {},
    width: 256,
    height: 256,
    resizable: true, // Enabled Resizing
  },
  'result-video': {
    type: 'result-video',
    label: 'Video Result',
    inputs: [{ key: 'in_res', type: 'GEN_VIDEO', label: 'Task', maxConnections: 1 }],
    outputs: [{ key: 'out_pass', type: 'VIDEO', label: 'Video' }],
    canDelete: true,
    canCopy: false,
    defaultData: {},
    width: 256,
    height: 256,
    resizable: true, // Enabled Resizing
  },
  'text-label': {
    type: 'text-label',
    label: 'Label',
    inputs: [],
    outputs: [],
    canDelete: true,
    canCopy: true,
    defaultData: { text: '' },
    width: 300,
    height: 180,
    resizable: true,
  },
  'group': {
    type: 'group',
    label: 'Group',
    inputs: [],
    outputs: [],
    canDelete: true,
    canCopy: true,
    defaultData: { label: 'Group' },
    isGroup: true,
    resizable: true,
  },
};